var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 30,
    viewBox: "0 0 77 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1024_10265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83221 29.3326L5.79187 25.7159L1.01904 25.7492L7.45641 12.1992L15.2696 15.7826L8.83221 29.3326Z",
    fill: "#FFC314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6092 29.3326L18.6496 25.7159L23.4224 25.7492L16.985 12.1992L9.17188 15.7826L15.6092 29.3326Z",
    fill: "#FFC314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2294 23.3333C18.7959 23.3333 24.119 18.11 24.119 11.6667C24.119 5.22334 18.7959 0 12.2294 0C5.663 0 0.339844 5.22334 0.339844 11.6667C0.339844 18.11 5.663 23.3333 12.2294 23.3333Z",
    fill: "#FFC314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2293 20.5499C17.2292 20.5499 21.2824 16.5727 21.2824 11.6665C21.2824 6.76041 17.2292 2.7832 12.2293 2.7832C7.22947 2.7832 3.17627 6.76041 3.17627 11.6665C3.17627 16.5727 7.22947 20.5499 12.2293 20.5499Z",
    fill: "#FFDC14",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3242 7.71484V16.1992H11.5547V9.39062H11.5078L9.5625 10.6094V9.05078L11.6602 7.71484H13.3242Z",
    fill: "#2B2B2B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1733 19.5V11.0156H29.9312V18.0469H33.5874V19.5H28.1733ZM37.5718 19.6289C35.6206 19.623 34.4253 18.3633 34.4312 16.3477C34.4253 14.3848 35.6382 13.0547 37.5015 13.0547C39.1714 13.0547 40.4897 14.1094 40.4897 16.2773V16.7695H36.1421C36.1421 17.7305 36.7104 18.3223 37.6069 18.3281C38.1987 18.3223 38.6206 18.0645 38.7905 17.6836H40.4429C40.1968 18.8613 39.1421 19.623 37.5718 19.6289ZM36.1421 15.6797H38.8491C38.8433 14.9062 38.3101 14.3496 37.5366 14.3555C36.7397 14.3496 36.1772 14.9473 36.1421 15.6797ZM47.3101 13.1367L45.0718 19.5H43.1265L40.8999 13.1367H42.728L44.064 17.707H44.1343L45.4702 13.1367H47.3101ZM50.8257 19.6289C48.8745 19.623 47.6792 18.3633 47.6851 16.3477C47.6792 14.3848 48.8921 13.0547 50.7554 13.0547C52.4253 13.0547 53.7437 14.1094 53.7437 16.2773V16.7695H49.396C49.396 17.7305 49.9644 18.3223 50.8608 18.3281C51.4526 18.3223 51.8745 18.0645 52.0444 17.6836H53.6968C53.4507 18.8613 52.396 19.623 50.8257 19.6289ZM49.396 15.6797H52.103C52.0972 14.9062 51.564 14.3496 50.7905 14.3555C49.9937 14.3496 49.4312 14.9473 49.396 15.6797ZM56.5679 11.0156V19.5H54.8335V11.0156H56.5679ZM64.3257 11.0156V19.5H62.5562V12.6914H62.5093L60.564 13.9102V12.3516L62.6616 11.0156H64.3257Z",
    fill: "#FFC314"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1024_10265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.4586,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.07a2f0f7634048e21f2f09b40d82ae62.svg";
export { ForwardRef as ReactComponent };